export { default as VariantsCarousel } from './VariantsCarousel';
